import { render, staticRenderFns } from "./FinvuSection.vue?vue&type=template&id=95866c04&scoped=true"
import script from "./FinvuSection.vue?vue&type=script&lang=js"
export * from "./FinvuSection.vue?vue&type=script&lang=js"
import style0 from "./FinvuSection.vue?vue&type=style&index=0&id=95866c04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95866c04",
  null
  
)

export default component.exports